import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../core/_BLComponent.jsx';

export default class ErrorModalBody extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

	}

	componentDidMount() 
	{

	}

	getTitle(errorType, strItemType) {
		let retStr = "";
		switch(errorType)
		{
			case "generalError" 	: 
			case "partoutError" 	:
			case "failure" 			:
										retStr = "Error adding " + strItemType;
								  		break;
			case "editError" 		: 	
										retStr = "Error updating My " + strItemType;
										break;

			case "editFailure"		: 	retStr = "Error editing My " + strItemType;
										break;
			case "updateQtyError"	: 	retStr = "Error saving changes"; 
										break;
		}
		return retStr;

	}

	getMessage(errorType, strItemType) {
		let retStr = "";
		switch(errorType)
		{
			case "generalError" 	: 	retStr = "Oops! There was an error adding this " + strItemType + " to My Collection. Please try again."
										break;
			case "partoutError" 	: 	retStr = "Oops! We were able to add this " + strItemType + ", but there was a problem adding the " + strItemType + " inventory to My Parts. Please try again."
										break;
			case "failure" 			: 	retStr = "Sorry, it seems like we’re having some problems on our end. Please try again later.";
								  		break;
			case "editError" 		: 	retStr = "Oops! There was an error updating your collection. Please try again.";
										break;
			case "editFailure"		: 	retStr = "Sorry, it seems like we’re having some problems on our end. Please try again later.";
										break;
		}
		return retStr;
	}


	render()
	{
		const listStrItemType = { S: "set", P:"part", M:"minifigure", B:"book", C:"catalog", G:"gear"};
		const errorType = this.props.data.errorType;
		const strItemType = listStrItemType[this.props.data.itemType];
		const title = this.getTitle(errorType, strItemType);
		const msg = this.getMessage(errorType, strItemType);
		
		return (
			<section className="personal-inventory__section-error-modal">
				<div className="l-flex l-center-v text--bold">{title}</div>
				<div className="l-margin-top--xl text--center">
					<i className="modal-icon--exclamation fas fa-exclamation-triangle"></i>
				</div>
				<div className="l-margin-top--xl l-margin-bottom text--center">
					{msg}
					{(errorType == "updateQtyError")&&this.renderUpdateQtyErrorMsg()}
				</div>
			</section>
		);
	}

	renderUpdateQtyErrorMsg() {
		return(
			<React.Fragment>
				<div>
					It looks like some of your changes have an error. The items with errors are highlighted in red.
				</div>
				<div className="l-margin-top--xl">
					If you are trying to remove an item from your collection, click the delete button on it or set the quantity to 0
				</div>
			</React.Fragment>
		)
	}


};

 

